import { ModalCreatePostsPolicyComponent } from './modal-create-posts-policy/modal-create-posts-policy.component';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { LayoutUtilsService } from '@app/core/_base/crud';
// Xóa MatPaginator khỏi import
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { BrandService } from '@app/api/api';
import { environment } from 'environments/environment';
import { debounceTime, map } from 'rxjs/operators';
import { PolicyService } from '@app/api/api';

import { Router } from '@angular/router';
@Component({
  selector: 'meu-app-policy-posts-management',
  templateUrl: './app-policy-posts-management.component.html',
  styleUrls: ['./app-policy-posts-management.component.scss'],
})
export class AppPolicyPostsManagementComponent {
  constructor(
    private layoutUtilsService: LayoutUtilsService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private brandService: BrandService,
    private policyService: PolicyService,
    private router: Router
  ) {}
  displayedColumns: string[] = ['Index', 'Logo', 'Name', 'Code', 'Country', 'Actions'];
  displayedColumns2: string[] = [
    'Index',
    'Title',
    'Description',
    // 'CreatedBy',
    // 'CreatedAt',
    'Actions',
  ];

  lstPolicy: any = [];
  lstAllBrand: any = [];
  total: any;
  pageSize = 10;
  pageIndex = 1;
  host: any;
  filter: any = '';

  pageSizeOptions: number[] = [5, 10, 20, 100];

  ngOnInit() {
    // this.keyUp
    //   .pipe(
    //     map((event) => event),
    //     debounceTime(500)
    //   )
    //   .subscribe((value) => {
    //     this.pageIndex = 1;
    //     this.pageSize = 10;
    //     // this.paginator.firstPage(); // Xóa dòng này
    //     this.filter = 'name|code|nation@=*' + value;
    //     this.getAllPolicies();
    //   });
    // this.getAllPolicies();
    this.getAllPolicies2();
  }
  public keyUp = new Subject<KeyboardEvent>();
  redirectToPolicy(slug) {
    this.router.navigate([`/privacy-policy/${slug}`]);
  }
  // getAllPolicies() {
  //   this.brandService
  //     .apiBrandsGet(this.filter, '', this.pageIndex, this.pageSize)
  //     .subscribe((res) => {
  //       if (res.success) {
  //         this.lstAllBrand = res.data.collection;
  //         // this.pageSize = res.data.pagesize; // Tắt dòng này
  //         // this.pageIndex = res.data.pageIndex; // Tắt dòng này
  //         this.total = res.data.total;
  //         this.host = environment.backendhost;
  //         this.ref.detectChanges();
  //       } else {
  //         this.toastr.error(res.message);
  //       }
  //     });
  // }
  getAllPolicies2() {
    this.policyService.apiPoliciesGet().subscribe((res) => {
      if (res.success) {
        if (res.success) {
          this.lstPolicy = res.data;

          // this.pageSize = res.data.pagesize; // Tắt dòng này
          // this.pageIndex = res.data.pageIndex; // Tắt dòng này
          // this.total = res.data.total;
          this.host = environment.backendhost;
          this.ref.detectChanges();
        } else {
          this.toastr.error(res.message);
        }
      }
    });
  }

  openModalBrand(id) {
    const dialogRef = this.dialog.open(ModalCreatePostsPolicyComponent, {
      width: '900px',
      data: { id: id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result.event != undefined) {
        if (result.event) {
          if (result.type == 'create') {
            this.toastr.success('Tạo bài viết mới thành công');
            this.getAllPolicies2();
          } else {
            this.toastr.success('Chỉnh sửa bài viết thành công');
            this.getAllPolicies2();
          }
        } else {
          // this.toastr.error(result.message);
          this.toastr.error('Đã có lỗi xảy ra');
        }
      }
    });
  }
  deleteBrand(ID) {
    const title = 'Xóa chính sách';
    const description = 'Bạn có chắc chắn muốn xóa chính sách này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.policyService.apiPoliciesIdDelete(ID).subscribe((res) => {
          if (res.success) {
            this.toastr.success('Xoá thành công');
            this.getAllPolicies2();
          } else {
            this.toastr.error(res.message);
          }
        });
      }
    });
  }
}
